import { CURRENCIES } from "./constants";

const DECIMALS = new Map(
  CURRENCIES.map((c) => [c.code, c.code === "jpy" ? 0 : 2])
);

export function currencySymbol(code) {
  const c = CURRENCIES.find((x) => x.code === code);
  return c ? c.symbol : "";
}

/**
 * Price formatting: 2 decimals when price >= 1 (0 for JPY),
 * up to 6 decimals when below 1.
 */
export function formatPrice(value, currency = "usd") {
  if (value === null || value === undefined || Number.isNaN(Number(value)))
    return "—";
  const base = DECIMALS.get(currency) ?? 2;
  const max = Math.abs(Number(value)) >= 1 ? base : Math.max(base, 6);
  const opts = {
    style: "currency",
    currency: currency.toUpperCase(),
    maximumFractionDigits: max,
    minimumFractionDigits: Math.min(base, 2),
  };
  try {
    return new Intl.NumberFormat("en-US", opts).format(value);
  } catch {
    return `${currencySymbol(currency)}${Number(value).toFixed(max)}`;
  }
}

export function formatCompact(value, currency = "usd") {
  if (value === null || value === undefined || Number.isNaN(Number(value)))
    return "—";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency.toUpperCase(),
      notation: "compact",
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${currencySymbol(currency)}${Number(value).toExponential(2)}`;
  }
}

/**
 * Percent with explicit sign: +1.23% / -4.56%.
 */
export function formatPercent(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value)))
    return "—";
  const sign = value > 0 ? "+" : "";
  const abs = Math.abs(Number(value));
  const digits = abs >= 100 ? 1 : abs >= 1 ? 2 : 4;
  return `${sign}${value.toFixed(digits)}%`;
}

export function formatNumberCompact(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value)))
    return "—";
  return new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 2,
  }).format(value);
}

export function percentClass(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value)))
    return "flat";
  return value > 0 ? "up" : value < 0 ? "down" : "flat";
}

export function relativeTime(ts) {
  if (!ts) return "";
  const s = Math.round((Date.now() - ts) / 1000);
  if (s < 5) return "just now";
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  return `${Math.floor(m / 60)}h ago`;
}
